import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'welcome.to.platform': {
    id: 'welcome.to.platform',
    defaultMessage: 'Welcome to {siteName}, {fullName}!',
    description: 'Welcome message that appears on progressive profile page',
  },
  'complete.your.profile.1': {
    id: 'complete.your.profile.1',
    defaultMessage: 'Complete',
    description: 'part of text "complete your profile"',
  },
  'complete.your.profile.2': {
    id: 'complete.your.profile.2',
    defaultMessage: 'your profile',
    description: 'part of text "complete your profile"',
  },
});

export default messages;
